export enum ESellCoinsCampaignStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CLOSED = 'closed'
}

export enum EIncentiveType {
  BONUS = 'bonus',
  PREDEFINEDDEAL = 'predefined-deal'
}

export enum EAutomaticCampaignName {
  loyalt = 'Automatically created based on your Loyalty Program',
  first = 'Automatically created'
}
